import { captureMessage } from '@sentry/react'

import {
  AudioFileErrorCode,
  getFileExtension,
} from 'src/Components/AudioFileUpload/validation'

export type TrackFileUploadFailureReason = AudioFileErrorCode | 'timeout'

export interface ReportTrackFileUploadFailureParams {
  reason: TrackFileUploadFailureReason
  campaignId: string
  file: File
}

export const TRACK_FILE_UPLOAD_FAILURE_MESSAGE =
  'Pre-release track upload failed'

export const reportTrackFileUploadFailure = ({
  reason,
  campaignId,
  file,
}: ReportTrackFileUploadFailureParams): void => {
  captureMessage(TRACK_FILE_UPLOAD_FAILURE_MESSAGE, {
    level: 'warning',
    fingerprint: [TRACK_FILE_UPLOAD_FAILURE_MESSAGE, reason],
    tags: { reason },
    extra: {
      campaignId,
      fileSize: file.size,
      fileType: file.type || getFileExtension(file.name),
    },
  })
}
